import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from '../componentes/Menu';
import dataSuper from '../hooks/Conf';
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
// Contexto
// import dataContext from "../context/User";

// Helper 
import loadMenu from '../js/main';
import Footer from '../componentes/Footer';

import '../css/styleAdmin.css';

const AlertMenu = () => {

    const history = useHistory();

    // const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    if (!datos) {
        history.push("/");
    }

    let cred = JSON.parse(datos);
    if (dataSuper.indexOf(cred.carnet.trim()) === -1) {
        if (dataDireccionEstudiantil.indexOf(cred.carnet.trim()) === -1) {
            history.push("/");
        }
    }

    datos = JSON.parse(datos);

    useEffect(() => {
        loadMenu();
    }, []);
    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto
                        foto={datos.carnet}
                        alt="Foto alumno"
                        tamanio="rounded" />

                    <HeaderMenu
                        carnet={datos.carnet}
                        nombre={datos.nombre}
                        perfil={datos.perfil}
                        carrera={datos.carrera}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">Envío de notificaciones</h2>
                <p className="text-muted mb-4">
                    Elige el canal al que deseas enviar una notificación push.
                </p>

                <h3 className="h5 mb-3">Alumnos</h3>
                <div className="esen-resource-grid mb-4">
                    {[
                        { ruta: "/adminpush", icono: "fa-users", nombre: "Todos los alumnos", detalle: "Todas las carreras" },
                        { ruta: "/pusheconomia", icono: "fa-line-chart", nombre: "Licenciatura en Economía y Negocios", detalle: "Por año de estudio" },
                        { ruta: "/pushderecho", icono: "fa-balance-scale", nombre: "Licenciatura en Ciencias Jurídicas", detalle: "Por año de estudio" },
                        { ruta: "/pushing", icono: "fa-cogs", nombre: "Ingeniería de Negocios", detalle: "Por año de estudio" },
                        { ruta: "/pushingsoft", icono: "fa-laptop", nombre: "Ingeniería de Software y Negocios Digitales", detalle: "Por año de estudio" },
                        { ruta: "/pushgeneraciones", icono: "fa-calendar", nombre: "Alumnos por generación", detalle: "Por año de ingreso" },
                    ].map((canal) => (
                        <Link key={canal.ruta} to={canal.ruta} className="card mb-0 text-decoration-none">
                            <div className="card-body d-flex align-items-center">
                                <span className="esen-empty-icon mb-0 mr-3">
                                    <i className={`fa ${canal.icono}`} aria-hidden="true"></i>
                                </span>
                                <span>
                                    <span className="h6 d-block mb-1">{canal.nombre}</span>
                                    <small className="text-muted">{canal.detalle}</small>
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>

                <h3 className="h5 mb-3">Personal</h3>
                <div className="esen-resource-grid">
                    {[
                        { ruta: "/pushadminesen", icono: "fa-university", nombre: "Personal ESEN", detalle: "Catedráticos y administrativos" },
                        { ruta: "/pushadmin", icono: "fa-briefcase", nombre: "Personal administrativo", detalle: "Solo administrativos" },
                        { ruta: "/pushprofesores", icono: "fa-graduation-cap", nombre: "Catedráticos", detalle: "Solo docentes" },
                    ].map((canal) => (
                        <Link key={canal.ruta} to={canal.ruta} className="card mb-0 text-decoration-none">
                            <div className="card-body d-flex align-items-center">
                                <span className="esen-empty-icon mb-0 mr-3">
                                    <i className={`fa ${canal.icono}`} aria-hidden="true"></i>
                                </span>
                                <span>
                                    <span className="h6 d-block mb-1">{canal.nombre}</span>
                                    <small className="text-muted">{canal.detalle}</small>
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    )

}

export default AlertMenu;